import { useAPI } from '@arema/components/Hooks';
import { addCommas, bindClick } from '@arema/components/Util';
import React, { useEffect, useState } from 'react';
import { Groupper, Header, Icon, Pagination, Table, Toolbar, useFrontier } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import { EventSectionProps } from '../../AdminClasses';
import { useUser } from '../../AdminHooks';
import API from '../../API';
import UserAccess from '../../UserAccess';

enum Modals{
	DELETE = 1,
}

const PAGE_SIZE = 50;
var EventCodeDetails = (props: EventSectionProps<{ code: string }>)=>{
	var { t } = useTranslation();
	var { hasAccess } = useUser();
	var { Toast } = useFrontier();
	var { data, load, loadError } = useAPI(API.getEventCodeGroup);
	var [page, setPage] = useState<number>(0);
	var [shownModal, setShownModal] = useState<Modals>(null);

	useEffect(()=>{
		if(!props.params.code) return;
		var group_id = parseInt(props.params.code);
		if(Number.isNaN(group_id)) return;
		if(!data || group_id!==data.group_id){
			load(props.event.event_id, group_id, PAGE_SIZE);
		}
	}, [props.params.code]);

	var downloadCodes = (all: boolean, used: boolean)=>{
		return ()=>{
			var tx = Toast.show(t('toasts.downloading'), {
				loading: true,
				dismissable: false
			});
			API.downloadEventCodes(data.group_id, all, used).then(res=>{
				if(res.error) return Toast.error(res.message);
				API.downloadLink(res.data.url, `Codigos-${data.code_prefix.toUpperCase()}${data.group_id}-${all ? 'TODOS' : used ? 'USADOS' : 'ACTIVOS'}.csv`)
			}).catch(err=>{
				return Toast.error(t('common.unexpected_code', { code: 'LCL-EVCDTL-DWL' }));
			}).finally(()=>{
				Toast.dismiss(tx);
			})
		}
	}

	if(loadError) return <Header text={t('common.error')} subtext={loadError} />
	if(!data) return <Header text={t('common.loading')} loading />

	return <div className='ar event-code-details-screen'>
		<Groupper style={{ maxWidth: 500 }} title={t('event_codes.title')}>
			<Toolbar>
				<Toolbar.Dropdown iconName='file-csv' text={t('common.download')} items={[
					{ text: t('event_codes.view.download.unused'), onClick: downloadCodes(false, false) },
					{ text: t('event_codes.view.download.used'), onClick: downloadCodes(false, true) },
					{ text: t('event_codes.view.download.all'), onClick: downloadCodes(true, false) },
				]} />
				<Toolbar.Dropdown iconName='pen' text={t('common.edit')} items={[
					{ text: t('common.delete'), style: { color: 'brown' }, onClick: bindClick(setShownModal, Modals.DELETE) }
				]} />
			</Toolbar>
			<Table details fitted removeMargin={['top']}>
				<Table.Body>
					<Table.Row data={['ID', data.group_id]} />
					<Table.Row data={[t('event_codes.create.name'), data.description]} />
					<Table.Row data={[t('event_codes.create.type'), t(`event_codes.types.type_${data.type_id}`)]} />
					<Table.Divider />
					<Table.Row data={[t('event_codes.view.count'), <>
						{/* <span style={{ fontWeight: 'bold' }}>{addCommas(data.code_active, false)}</span>
						<span style={{ fontSize: 12 }}>/{addCommas(data.code_count, false)}</span>	 */}
						{addCommas(data.code_count, false)}
					</>]} />
				</Table.Body>
			</Table>
			<Table fitted removeBorder={['top']} last>
				<Table.Head title={t('event_codes.view.codes')} />
				<Table.Body>
					{!hasAccess(UserAccess.EVENTS.VIEW_EVENT_CODES) ? (
						<Table.Cell row empty colSpan={100} value={t('event_codes.view.no_access')} />
					) : data.codes.length===0 ? (
						<Table.Cell row empty colSpan={100} value={t('event_codes.view.empty')} />
					) : null}
					{!!data.codes && data.codes.slice(page*PAGE_SIZE, ((page+1)*PAGE_SIZE)).map(a=>(
						<Table.Row collapsingIndexes={[0, 2]} key={`EVCD-${a.code_id}`} data={[
							a.code_id, 
							<div className='fr mono'>{a.code}</div>,
							// <>
							// 	<Icon name={a.used ? 'check' : 'thumbs-up'} color={a.used ? 'green' : 'black'} />
							// 	<span style={{ fontWeight: 'bold' }}>{addCommas(a.uses, false)}</span>
							// 	<span style={{ fontSize: 12 }}>/{addCommas(data.code_uses, false)}</span>	
							// </>
						]} />
					))}
				</Table.Body>
				<Table.Footer actions={(
					<Pagination page={page} pageCount={Math.ceil(data.codes.length/PAGE_SIZE)} onPageChange={setPage} />
				)} />
			</Table>
		</Groupper>
	</div>
}

export default EventCodeDetails;